export default {
  account(st, gt, rSt) {
    return rSt.auth.account;
  },
  hasPermission(st, gt, rSt) {
    if (rSt.auth.account && rSt.auth.account.role[0].name !== 'pesquisador') {
      return true;
    }
    return false;
  },
  isAdmin(st, gt, rSt) {
    if (rSt.auth.account && rSt.auth.account.role[0].name === 'admin') {
      return true;
    }
    return false;
  },
  isOperador(st, gt, rSt) {
    if (rSt.auth.account && rSt.auth.account.role[0].name === 'operador') {
      return true;
    }
    return false;
  },
  showTable(st) {
    return st.showTable;
  },
  items(st) {
    if (st.items) {
      return st.items.map(item => ({
        id: item.id,
        registro: item.suporteBase
            && item.suporteBase[0].registro1 && item.suporteBase[0].registro2 && `${item.suporteBase[0].registro1.trim()} ${item.suporteBase[0].registro2.trim()}`,
        publicador: item.publicador && item.publicador.name,
        nome: item.nome,
        dtImagem: item.dtImagem,
        dtLimite: item.dtLimite,
        localizacaoFisica: item.suporteBase && item.suporteBase.reduce((acc, val) => acc += `${val.localizacaoFisica}; `, ''),
        createdAt: item.createdAt,
        idTipoPublicacao: item.tipoPublicacao && item.tipoPublicacao.tipoPublicacao,
        url: item.tipoPublicacao && item.tipoPublicacao.etapas,
        statusFluxo: item.statusFluxo,
        arquivo: item.documentos && item.documentos[0],
      }));
    }
    return [];
  },
  headers(st, gt) {
    if (gt.hasPermission) {
      return [
        {
          text: 'Registro',
          align: 'left',
          sortable: false,
          value: 'registro',
        },
        {
          text: 'Colaborador',
          align: 'left',
          sortable: false,
          value: 'publicador',
        },
        {
          text: 'Título',
          align: 'left',
          sortable: true,
          value: 'nome',
        },
        {
          text: 'Data do doc.',
          align: 'left',
          sortable: true,
          value: 'dt_imagem',
        },
        {
          text: 'Acervo',
          align: 'left',
          sortable: true,
          value: 'id_tipo_publicacao',
        },
        {
          text: 'Status',
          align: 'left',
          sortable: true,
          value: 'status_fluxo',
        },
        {
          text: 'Localização',
          align: 'left',
          sortable: false,
          value: 'localizacaoFisica',
        },
        { text: '', value: 'action', sortable: false },
      ];
    }
    return [
      {
        text: 'Registro',
        align: 'left',
        sortable: false,
        value: 'registro',
      },
      {
        text: 'Título',
        align: 'left',
        sortable: true,
        value: 'nome',
      },
      {
        text: 'Data do doc.',
        align: 'left',
        sortable: true,
        value: 'dt_imagem',
      },
      {
        text: 'Acervo',
        align: 'left',
        sortable: true,
        value: 'id_tipo_publicacao',
      },
      { text: 'Ação', value: 'action', sortable: false },
    ];
  },
  footerProps() {
    return {
      itemsPerPageOptions: [10, 20, 40, 80],
      showFirstLastPage: true,
    };
  },
  totalItems(st) {
    return st.totalItems;
  },
  loading(st) {
    return st.loading;
  },
  registerLoading(st) {
    return st.registerLoading;
  },
  options(st) {
    return st.options;
  },
  deleteItem(st) {
    return st.deleteItem;
  },
  bulkDeleteItems(st) {
    return st.bulkDeleteItems;
  },
  bulkHideItems(st) {
    return st.bulkHideItems;
  },
  deleteDialog(st) {
    return st.deleteDialog;
  },
  bulkDeleteDialog(st) {
    return st.bulkDeleteDialog;
  },
  bulkHideDialog(st) {
    return st.bulkHideDialog;
  },
  registerDialog(st) {
    return st.registerDialog;
  },
  registerAccount(st) {
    return st.registerAccount;
  },
  blockItem(st) {
    return st.blockItem;
  },
  blockDialog(st) {
    return st.blockDialog;
  },
  collection(st) {
    return st.collection;
  },
  collections(st) {
    return st.collections;
  },
  segmentos(st) {
    return st.segmentos;
  },
  searchType(st) {
    return st.searchType;
  },
  suportes(st) {
    return st.suportes;
  },
  idiomas(st) {
    return st.idiomas;
  },
  filter(st) {
    return st.filter;
  },
  globalSearch(st) {
    return st.globalSearch;
  },
  emptyFilter() {
    return {
      conditionals: {
        first: {
          select: 'sinopse',
          conditional: 'AND',
        },
        second: {
          select: 'nome',
          conditional: 'AND',
        },
        third: {
          select: 'conteudo',
          conditional: 'AND',
        },
        fourth: {
          select: 'palavrachave',
          conditional: 'AND',
        },
        fifth: {
          select: 'autor',
          conditional: 'AND',
        },
      },
      idioma: {
        idiomaConditional: 'AND',
      },
      suporte: {
        suporteConditional: 'AND',
      },
    };
  },
  accounts(st) {
    return st.accounts.filter(account => account.role[0].name !== 'pesquisador');
  },
};
